<div class="flex w-full justify-start pl-8 pt-8">
  <button class="btn-text w-fit items-center" (click)="onBackClick()">
    <svg-icon class="text-primary-blue" key="px-16-arrow-left"></svg-icon>
    {{ 'imaging_back_button' | translate }}
  </button>
</div>

<div class="flex w-full max-w-3xl flex-1 flex-col items-center justify-start gap-6 px-8">
  @if (profile(); as profile) {
    <div class="flex flex-col items-center justify-center gap-3">
      <lib-avatar-initials [name]="profile" [size]="64" [fontSize]="28"></lib-avatar-initials>
      @if (isEditingName()) {
        <div class="mt-4 flex items-end gap-2">
          <div class="flex flex-col gap-1">
            <label class="text-h7 text-text-secondary">First name</label>
            <lib-input
              [formControl]="profileForm.controls.firstName"
              placeholder="First Name"
              size="normal"
              (keydown)="onNameKeyDown($event)"
            ></lib-input>
          </div>
          <div class="flex flex-col gap-1">
            <label class="text-h7 text-text-secondary">Last name</label>
            <lib-input
              [formControl]="profileForm.controls.lastName"
              placeholder="Last Name"
              size="normal"
              (keydown)="onNameKeyDown($event)"
            ></lib-input>
          </div>
          <button class="text-sm btn-secondary px-4 py-2" (click)="onCancelNameEdit()" type="button">
            {{ 'common_teeth_selector_cancel_button' | translate }}
          </button>
          <button
            class="text-sm btn-primary px-4 py-2"
            (click)="onSaveNameClick()"
            type="button"
            [disabled]="!profileForm.controls.firstName.valid || !profileForm.controls.lastName.valid"
          >
            {{ 'notes_save_button' | translate }}
          </button>
        </div>
      } @else {
        <div class="flex items-center gap-2">
          <p class="typo-h3-semibold">{{ profile.firstName }} {{ profile.lastName }}</p>
          @if (!isFfdNotes) {
            <button
              class="hover:text-primary-blue-dark flex h-6 w-6 items-center justify-center text-primary-blue transition-colors"
              (click)="onEditNameClick()"
              type="button"
            >
              <svg-icon key="px-16-edit" [fontSize]="16"></svg-icon>
            </button>
          }
        </div>
      }
    </div>
    <div class="flex w-full flex-col">
      <form class="flex w-full flex-col gap-6" [formGroup]="profileForm">
        <lib-input
          [formControl]="profileForm.controls.email"
          [label]="'account_email_section_title' | translate"
          [readOnlyField]="true"
          [readonlyBackground]="isFfdNotes ? 'white' : 'light-grey'"
          labelPosition="above"
          size="large"
        ></lib-input>
        <!-- @if (profileForm.controls.role.value) {
        <lib-input
          [formControl]="profileForm.controls.role"
          [label]="'account_role_section_title' | translate"
          [readOnlyField]="true"
          labelPosition="above"
          size="large"
        ></lib-input>
      } -->
      </form>

      @if (isFfdNotes && practiceInfo(); as practice) {
        <div class="flex w-full flex-col gap-2">
          <div class="rounded-2xl bg-background-light-blue px-4 py-3">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-3">
                <svg-icon key="px-24-tick" class="flex-shrink-0 text-text-primary"></svg-icon>
                <span class="typo-h4-medium text-text-primary">{{ 'express_account_quota_section_title' | translate }}</span>
              </div>
              <div class="flex flex-col items-end">
                <span class="typo-h4-medium-line-height-20 text-text-tertiary">{{ 'express_account_quota_section_info' | translate }}</span>
              </div>
            </div>
          </div>

          <cdk-accordion>
            <div class="mb-2 rounded-2xl bg-background-light-blue px-4 py-3">
              <cdk-accordion-item #practiceAccordion="cdkAccordionItem" [expanded]="false">
                <div (click)="practiceAccordion.toggle()">
                  <div class="flex items-center justify-between gap-2">
                    <svg-icon key="px-24-front-office"></svg-icon>
                    <h4 class="typo-h4-medium-line-height-20 flex-grow">{{ 'express_account_baa_section_my_practice' | translate }}</h4>
                    <svg-icon
                      class="text-primary-blue"
                      [key]="practiceAccordion.expanded ? 'px-16-arrow-up' : 'px-16-arrow-down'"
                    ></svg-icon>
                  </div>
                </div>
                <div [style.display]="practiceAccordion.expanded ? '' : 'none'" class="flex flex-col gap-3 px-8 pt-6">
                  <p class="typo-h4-semibold text-text-secondary">{{ practice.name }}</p>
                  @if (signedContractUrl(); as url) {
                    <a [href]="url" target="_blank" class="flex items-center gap-1 text-primary-blue">
                      <svg-icon key="px-24-download" size="sx" class="flex-shrink-0"></svg-icon>
                      <span class="typo-h5-semibold">{{ 'express_account_baa_section_download_baa' | translate }}</span>
                    </a>
                  }
                </div>
              </cdk-accordion-item>
            </div>

            @if (practice.isContractSignedByCurrentUser) {
              <div class="mb-6 rounded-2xl bg-background-light-blue px-4 py-3">
                <cdk-accordion-item #inviteTeamAccordion="cdkAccordionItem" [expanded]="false">
                  <div (click)="inviteTeamAccordion.toggle()">
                    <div class="flex items-center justify-between gap-2">
                      <svg-icon key="px-24-invite"></svg-icon>
                      <h4 class="typo-h4-medium-line-height-20 flex-grow">
                        {{ 'express_account_baa_section_invite_team' | translate }}
                      </h4>
                      <svg-icon
                        class="text-primary-blue"
                        [key]="inviteTeamAccordion.expanded ? 'px-16-arrow-up' : 'px-16-arrow-down'"
                      ></svg-icon>
                    </div>
                  </div>
                  <div [style.display]="inviteTeamAccordion.expanded ? '' : 'none'" class="flex flex-col gap-3 px-8 pt-1">
                    <p class="typo-h7-light text-text-secondary">{{ 'express_account_baa_section_invite_message' | translate }}</p>
                    <button type="button" class="btn-primary w-fit" [disabled]="isInviteLinkLoading()" (click)="onShareInviteClick()">
                      <svg-icon key="px-16-share" size="md" currentcolor></svg-icon>
                      <span class="text-nowrap">{{ 'express_account_baa_section_invite_share' | translate }}</span>
                    </button>
                  </div>
                </cdk-accordion-item>
              </div>
            }
          </cdk-accordion>
        </div>
      }
    </div>
    @if (!isFfdNotes) {
      <div class="flex w-full flex-col gap-2">
        <div class="typo-h5-book text-text-light">{{ 'account_practices_title' | translate }}</div>
        <div class="mb-6 flex flex-col rounded-2xl bg-background-light-blue p-1">
          <div class="typo-h7-book flex h-8 items-center text-text-tertiary">
            <div class="w-[200px] shrink-0 p-2">{{ 'account_practices_name_title' | translate }}</div>
            <div class="w-40 shrink-0 p-2">{{ 'account_practices_user_name_title' | translate }}</div>
            <div class="w-[120px] shrink-0 p-2">{{ 'account_practices_access_title' | translate }}</div>
            <div class="min-w-0 flex-1 p-2 opacity-0">{{ 'account_practices_actions_title' | translate }}</div>
          </div>
          @for (site of profile.sites; track site.id; let last = $last) {
            @if (site.id !== 'showcase') {
              <div class="flex items-stretch">
                <div class="flex w-[200px] shrink-0 flex-col justify-center gap-1 px-2 py-1">
                  <div class="typo-h5-medium line-clamp-1 text-text-primary">
                    {{ site.name }}
                  </div>
                  @if (site.postfix) {
                    <div class="typo-h6-light line-clamp-1 text-text-primary">
                      {{ site.postfix }}
                    </div>
                  }
                  @if (hasEaglesoftPasswordIssue(site)) {
                    <div class="typo-h7-extralight flex items-center gap-1 text-text-tertiary">
                      <svg-icon key="px-24-warning-2" [fontSize]="12" class="rounded-full bg-states-orange text-text-white"></svg-icon>
                      {{ 'account_practices_update_password_hint' | translate }}
                    </div>
                  }
                </div>
                <div class="flex w-40 shrink-0 flex-col justify-center px-2 py-1">
                  <div class="typo-h5-medium line-clamp-1 text-text-primary">
                    {{ site.provider?.firstName || site.staff?.firstName }} {{ site.provider?.lastName || site.staff?.lastName }}
                  </div>
                  <div class="typo-h6-light line-clamp-1 text-text-primary">
                    {{ (site.provider | pmsDisplayCode) || site.staff?.pmsId }}
                  </div>
                </div>
                <div class="flex w-[120px] shrink-0 items-center px-2 py-1">
                  <div class="typo-h5-medium line-clamp-1 text-text-primary">
                    {{
                      site.provider?.accessType === 'FULL_ACCESS' || site.staff?.accessType === 'FULL_ACCESS'
                        ? ('account_practices_user_role_internal' | translate)
                        : ('account_practices_user_role_external' | translate)
                    }}
                  </div>
                </div>
                <div class="flex min-w-0 flex-1 items-center justify-end gap-[30px] px-2 py-1">
                  @if (isEaglesoftSite(site)) {
                    <button
                      class="typo-h7-semibold hover:text-primary-blue-dark flex w-fit items-center gap-1 whitespace-nowrap text-primary-blue transition-colors hover:underline"
                      (click)="onSetPasswordClick(site)"
                      type="button"
                    >
                      {{ 'account_practices_set_password_action' | translate }}
                      @if (hasEaglesoftPasswordIssue(site)) {
                        <lib-notification-dot></lib-notification-dot>
                      }
                    </button>
                  }
                </div>
              </div>
              @if (!last) {
                <div class="my-1 border-b border-background-disabled"></div>
              }
            }
          }
        </div>
      </div>
    }

    <div class="flex w-full flex-col gap-2">
      <div class="typo-h5-book text-text-light">{{ 'account_help_contact_section_title' | translate }}</div>
      <cdk-accordion [multi]="true">
        @if (isFfdNotes) {
          <div class="mb-6 rounded-2xl bg-background-light-blue px-4 py-3">
            <h6 class="typo-h5-extralight mb-4 text-text-secondary">{{ 'account_help_contact_section_description' | translate }}</h6>

            <div class="flex flex-col gap-4">
              <cdk-accordion-item #phoneAccordionItem="cdkAccordionItem" role="button" tabindex="0" [expanded]="false">
                <div (click)="phoneAccordionItem.toggle()">
                  <div class="flex items-center justify-between gap-2">
                    <svg-icon [key]="'px-24-phone'"></svg-icon>
                    <h4 class="typo-h4-medium-line-height-20 flex-grow">{{ 'account_help_contact_phone_title' | translate }}</h4>
                    <svg-icon
                      class="text-primary-blue"
                      [key]="phoneAccordionItem.expanded ? 'px-16-arrow-up' : 'px-16-arrow-down'"
                    ></svg-icon>
                  </div>
                  <div class="typo-h5-extralight px-8" [style.display]="phoneAccordionItem.expanded ? '' : 'none'">
                    <h5 class="typo-h5-extralight my-1 mb-3 whitespace-pre-wrap text-text-secondary">
                      {{ 'account_help_contact_phone_description' | translate }}
                    </h5>
                    <a
                      class="typo-h5-semibold text-primary-blue"
                      target="_blank"
                      [href]="'tel:' + ('account_help_contact_phone_action' | translate)"
                    >
                      {{ 'account_help_contact_phone_action' | translate }}
                    </a>
                    or
                    <a
                      class="typo-h5-semibold text-primary-blue"
                      target="_blank"
                      [href]="'tel:' + ('account_help_contact_phone_action2' | translate)"
                    >
                      {{ 'account_help_contact_phone_action2' | translate }}
                    </a>
                    (Toll-free)
                  </div>
                </div>
              </cdk-accordion-item>

              <cdk-accordion-item #emailAccordionItem="cdkAccordionItem" role="button" tabindex="0" [expanded]="false">
                <div (click)="emailAccordionItem.toggle()">
                  <div class="flex items-center justify-between gap-2">
                    <svg-icon [key]="'px-24-message'"></svg-icon>
                    <h4 class="typo-h4-medium-line-height-20 flex-grow">{{ 'account_help_contact_email_title' | translate }}</h4>
                    <svg-icon
                      class="text-primary-blue"
                      [key]="emailAccordionItem.expanded ? 'px-16-arrow-up' : 'px-16-arrow-down'"
                    ></svg-icon>
                  </div>
                  <div class="px-8" [style.display]="emailAccordionItem.expanded ? '' : 'none'">
                    <h6 class="typo-h5-extralight my-1 text-text-secondary">{{ 'account_help_contact_email_description' | translate }}</h6>
                    <a
                      class="typo-h5-semibold text-primary-blue"
                      target="_blank"
                      [href]="'mailto:' + ('account_help_contact_email_action' | translate)"
                    >
                      {{ 'account_help_contact_email_action' | translate }}
                    </a>
                  </div>
                </div>
              </cdk-accordion-item>
            </div>
          </div>
        } @else {
          <button
            class="mb-6 flex w-full items-center justify-between rounded-2xl bg-background-light-blue px-4 py-3"
            type="button"
            (click)="onSupportClick()"
          >
            <span class="flex items-center gap-2">
              <svg-icon key="px-24-message-2"></svg-icon>
              <h4 class="typo-h4-medium-line-height-20">{{ 'account_help_contact_support_center_title' | translate }}</h4>
            </span>
            <svg-icon key="px-16-arrow-right" class="text-primary-blue"></svg-icon>
          </button>
        }

        @if (isFfdNotes) {
          <div class="rounded-2xl bg-background-light-blue px-4 py-3">
            <cdk-accordion-item #deleteAccount="cdkAccordionItem" role="button" tabindex="0" [expanded]="false">
              <div (click)="deleteAccount.toggle()">
                <div class="flex items-center justify-between gap-2">
                  <svg-icon [key]="'px-16-delete'"></svg-icon>
                  <h4 class="typo-h4-medium-line-height-20 flex-grow">
                    {{ 'account_help_contact_express_delete_account_title' | translate }}
                  </h4>
                  <svg-icon class="text-primary-blue" [key]="deleteAccount.expanded ? 'px-16-arrow-up' : 'px-16-arrow-down'"></svg-icon>
                </div>
                <div class="px-8" [style.display]="deleteAccount.expanded ? '' : 'none'">
                  <h6 class="typo-h5-extralight my-1 whitespace-pre-wrap text-text-secondary">
                    {{ 'account_help_contact_express_delete_account_description' | translate }}
                  </h6>
                  <a class="typo-h5-semibold text-primary-blue" (click)="onRequestDeleteAccountClick()" target="_blank">
                    {{ 'account_help_contact_express_delete_account_email' | translate }}
                  </a>
                </div>
              </div>
            </cdk-accordion-item>
          </div>
        }
      </cdk-accordion>
    </div>
    <button
      class="typo-h4-medium flex flex-row items-center gap-2 text-states-red hover:font-semibold hover:text-states-deep-red"
      (click)="logoutClick()"
    >
      <svg-icon key="px-24-logout" [fontSize]="16"></svg-icon>
      <span>{{ 'common_header_log_out' | translate }}</span>
    </button>
  }
</div>
<div class="mb-6 text-text-tertiary">{{ 'account_build_number' | translate }} {{ appVersion }}</div>
@if (!isFfdNotes) {
  <div class="mb-2 text-h6 text-text-tertiary">
    <a href="https://secure.ffd.ai/licenses/frontend-licenses.csv">Frontend app licenses</a>
  </div>
  <div class="mb-6 text-h6 text-text-tertiary">
    <a href="https://secure.ffd.ai/licenses/backend-cloud-licenses.csv">Backend cloud app licenses</a>
  </div>
}
